/** Home page awards and talks: plain rows of a title and a year. */
import React from 'react';

import { useSiteMetadata } from '../../../utils/hooks';

import * as styles from './homePage.module.less';

/** Render one titled section of title/date rows. */
export const DatedList = ({ heading, items }) => (
  <div className={styles.homepageSection}>
    <div className={styles.sectionHeading}>
      <h2>{heading}</h2>
    </div>
    <ul className={styles.datedList}>
      {items.map((item) => (
        <li key={`${item.date || 'undated'}-${item.title}`} className={styles.datedListItem}>
          <span className={styles.datedListTitle}>
            {item.url ? (
              <a href={item.url} target="_blank" rel="noopener noreferrer">{item.title}</a>
            ) : item.title}
          </span>
          <span className={styles.datedListDate}>{item.date}</span>
        </li>
      ))}
    </ul>
  </div>
);

/** Render every award; the list is short enough to show in full. */
const Awards = () => {
  const { awards } = useSiteMetadata();
  if (!awards || awards.length === 0) return null;
  return <DatedList heading="Awards & Scholarships" items={awards} />;
};

export default Awards;
